/*
 * @Date: 2019-08-21 18:02:52
 * @LastEditors: x
 * @LastEditTime: 2023-06-12 15:54:36
 */
import api from './api'

const url = 'pay'

export default {
  //购买证书的支付入口
  sendBuyCertificateInput(data) {
    return api.post(`${url}/BuyCertificate`,data)
  },
  getSignEnableIphones() {
    return api.get(`${url}/SignEnableIphones`)
  }

}


// WEBPACK FOOTER //
// ./src/api/pay.js